import api from '../config/axios';

export const getConnectedAccounts = () => api.get('/api/integrations/accounts');
export const connectGoogle = () => api.get('/api/integrations/google/connect');
export const disconnectAccount = (id) => api.delete(`/api/integrations/accounts/${id}`);
export const getGoogleProperties = (accountId) => api.get(`/api/integrations/google/properties/${accountId}`);


// Google Search Console endpoints
export const getGscSites = (accountId) => api.get(`/api/integrations/google/gsc/sites/${accountId}`);
export const queryGsc = (accountId, params) => api.post(`/api/integrations/google/gsc/query/${accountId}`, params);

// Google Analytics 4 endpoints
export const getGa4Properties = (accountId) => api.get(`/api/integrations/google/ga4/properties/${accountId}`);
export const runGa4Report = (accountId, params) => api.post(`/api/integrations/google/ga4/report/${accountId}`, params);

// Dashboard summary (combined GSC + GA4)
export const getGoogleDashboardSummary = (accountId, params) => api.post(`/api/integrations/google/dashboard-summary/${accountId}`, params);

// Property selection endpoints
export const saveAccountSettings = (accountId, settings) => api.put(`/api/integrations/accounts/${accountId}/settings`, settings);
export const getAccountSettings = (accountId, domain) => api.get(`/api/integrations/accounts/${accountId}/settings/${encodeURIComponent(domain)}`);

// Google Ads endpoints (per-user OAuth)
export const getAdsAccounts = (accountId) => api.get(`/api/integrations/google/ads/accounts/${accountId}`);
export const saveAdsCustomer = (accountId, adsCustomerId) => api.post(`/api/integrations/google/ads/customer/${accountId}`, { adsCustomerId });
